import {Link} from 'react-router-dom';

import MenuItem from './MenuItem';

const MenuLink = props => <MenuItem Element={Link} {...props} />;

export default MenuLink;
